import React from "react";
import { Helmet } from "react-helmet";
import { useStaticQuery, graphql } from "gatsby";
import { ENUMS } from "../libs/globals";

import siteImage from "../assets/img/wtewe-opengraph.jpg";

function SEO({
	title,
	description,
	social,
	metaType = ENUMS.META_TYPES.SITE,
}) {
	const { site } = useStaticQuery(
		graphql`
			query {
				site {
					siteMetadata {
						title
						description
						author
						siteURL
						functionsURL
						facebookAppID
						twitterUsername
					}
				}
			}
		`
	);

	const metaSite = [
		{
			property: `og:title`,
			content: site.siteMetadata.title,
		},
		{
			property: `og:description`,
			content: site.siteMetadata.description,
		},
		{
			property: `og:url`,
			content: `${site.siteMetadata.siteURL}`,
		},
		{
			property: `og:type`,
			content: `website`,
		},
		{
			property: `og:image`,
			content: `${process.env.SITE_URL}${siteImage}`,
		},
	];

	const metaPledge = [
		{
			property: `og:title`,
			content: site.siteMetadata.title,
		},
		{
			property: `og:description`,
			content: site.siteMetadata.description,
		},
		{
			property: `og:url`,
			content: `${site.siteMetadata.siteURL}/pledge-wall/?u=${social?.uid}`,
		},
		{
			property: `og:type`,
			content: `website`,
		},
		{
			property: `og:image`,
			content: `${
				site.siteMetadata.functionsURL
			}/screenshot?url=${encodeURIComponent(
				`${site.siteMetadata.siteURL}/social-pledge/?u=${social?.uid}`
			)}`,
		},
		{
			property: `og:image:width`,
			content: `1200`,
		},
		{
			property: `og:image:height`,
			content: `630`,
		},
		{
			property: `twitter:image`,
			content: `${
				site.siteMetadata.functionsURL
			}/screenshot?url=${encodeURIComponent(
				`${site.siteMetadata.siteURL}/social-pledge/?u=${social?.uid}`
			)}`,
		},
		{
			property: `twitter:image:width`,
			content: `1200`,
		},
		{
			property: `twitter:image:height`,
			content: `630`,
		},
	];

	const metaQuiz = [
		{
			property: `og:title`,
			content: site.siteMetadata.title,
		},
		{
			property: `og:description`,
			content: site.siteMetadata.description,
		},
		{
			property: `og:url`,
			content: `${site.siteMetadata.siteURL}/quiz/?q=${social?.key}&social=${social?.key}`,
		},
		{
			property: `og:type`,
			content: `website`,
		},
		{
			property: `og:image`,
			content: `${
				site.siteMetadata.functionsURL
			}/screenshot?url=${encodeURIComponent(
				`${site.siteMetadata.siteURL}/social-question/?q=${social?.key}`
			)}`,
		},
		{
			property: `og:image:width`,
			content: `1200`,
		},
		{
			property: `og:image:height`,
			content: `630`,
		},
		{
			property: `twitter:image`,
			content: `${
				site.siteMetadata.functionsURL
			}/screenshot?url=${encodeURIComponent(
				`${site.siteMetadata.siteURL}/social-question/?q=${social?.key}`
			)}`,
		},
		{
			property: `twitter:image:width`,
			content: `1200`,
		},
		{
			property: `twitter:image:height`,
			content: `1200`,
		},
	];

	const metaFacebook = [
		{
			property: `fb:app_id`,
			content: site.siteMetadata.facebookAppID,
		},
	];

	const metaTwitter = [
		{
			name: `twitter:card`,
			content: `summary_large_image`,
		},
		{
			name: `twitter:site`,
			content: site.siteMetadata.twitterUsername,
		},
		{
			name: `twitter:creator`,
			content: site.siteMetadata.twitterUsername,
		},
	];

	return (
		<Helmet
			title={title}
			titleTemplate={`%s | ${site.siteMetadata.title}`}
			meta={[
				{
					name: `description`,
					content:
						description ||
						site.siteMetadata.description,
				},
				...(metaType === ENUMS.META_TYPES.SITE
					? metaSite
					: []),
				...(metaType === ENUMS.META_TYPES.QUIZ
					? metaQuiz
					: []),
				...(metaType === ENUMS.META_TYPES.PLEDGE
					? metaPledge
					: []),
				...metaTwitter,
				...metaFacebook,
			]}
		/>
	);
}

export default SEO;
